import { z } from "zod";

export const PERIOD_KINDS = ["rolling_12m", "fiscal_year", "custom"] as const;
export type PeriodKind = (typeof PERIOD_KINDS)[number];
export const periodKindSchema = z.enum(PERIOD_KINDS);

export const periodInputSchema = z.discriminatedUnion("kind", [
  z.object({ kind: z.literal("rolling_12m") }),
  z.object({ kind: z.literal("fiscal_year"), fiscalYearLabel: z.string().min(4) }),
  z.object({
    kind: z.literal("custom"),
    start: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    end: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  }),
]);
export type PeriodInput = z.infer<typeof periodInputSchema>;

export const resolvedPeriodSchema = z.object({
  kind: periodKindSchema,
  current: z.object({ start: z.string(), end: z.string() }),
  previous: z.object({ start: z.string(), end: z.string() }),
});
export type ResolvedPeriod = z.infer<typeof resolvedPeriodSchema>;
